import { render, staticRenderFns } from "./ApplicationFormIndividualMisc.vue?vue&type=template&id=790fa604&scoped=true"
import script from "./ApplicationFormIndividualMisc.vue?vue&type=script&lang=ts"
export * from "./ApplicationFormIndividualMisc.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790fa604",
  null
  
)

export default component.exports